import { request } from "./request";

// 公司基础信息
export function companyAddress() {
    return request({
        method: 'get',
        url: '/api/sys/companyAddress/queryInfoPC',
    })
}

// 发展历程查询
export function developmentHistory() {
    return request({
        method: 'get',
        url: '/api/sys/developmentHistory/queryInfoPC',
    })
}

// 资质、荣誉查询
export function honorQuality(data) {
    return request({
        method: 'get',
        url: '/api/sys/honorQuality/queryInfoPC',
        params: data
    })
}
// 查询知识产权信息
export function intellectualProperty() {
    return request({
        method: 'get',
        url: '/api/sys/intellectualProperty/queryInfoPC',
    })
}

// 联系我们
export function contactUs(queryData) {
    return request({
        method: 'post',
        url: '/api/sys/contactUs/add',
        data: queryData
    })
}

// 留言
export function platformTrial(queryData) {
    return request({
        method: 'post',
        url: '/api/sys/platformTrial/add',
        data: queryData
    })
}

// 新闻模块接口
export function getNewsData() {
    return request({
        method: 'get',
        url: '/api/sys/news/queryInfoPC',
    })
}

// 新闻详情查询
export function queryInfoById(data) {
    return request({
        method: 'get',
        url: '/api/sys/news/queryInfoById',
        params: data
    })
}
